/**
 * BuildDirect — Quiz frame instrumentation
 *
 * The floor finder's problem is a number nobody can currently break down: 22% of
 * visitors start the quiz. That single figure covers at least three different
 * failures, and the fix for each is different:
 *
 *   - never saw the quiz          → it is too far down the page
 *   - saw it and did not start    → the invitation is not working
 *   - left for somewhere else     → the visitor wanted something else entirely
 *
 * These events separate them. GTM (GTM-TWC9KZRX) is installed site-wide, so they
 * are dataLayer pushes like every other event in this theme.
 *
 * What is NOT here: anything about progress inside the quiz. That runs in an
 * iframe on app.veeform.com, and this script does not guess at its postMessage
 * contract. Start, completion and drop-off per question are VeeForm's own
 * reporting; see docs/floor-finder-2026-08.md.
 */
(function () {
  'use strict';

  var frame = document.querySelector('[data-quiz-frame]');
  if (!frame) return;

  function push(event, payload) {
    window.dataLayer = window.dataLayer || [];
    var data = { event: event };
    for (var key in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, key)) data[key] = payload[key];
    }
    window.dataLayer.push(data);
  }

  var anchor = frame.getAttribute('data-quiz-anchor') || '';
  var layout = frame.getAttribute('data-quiz-layout') || '';
  var embedded = frame.getAttribute('data-quiz-embedded') === 'true';

  push('floor_finder_view', {
    quiz_layout: layout,
    quiz_embedded: embedded
  });

  /* ---- Was the quiz ever actually looked at? ---------------------------- */

  /* Half the frame, held for a second. A frame that clips the top of the
     viewport for 80ms during a fast scroll to the footer was not seen, and
     counting it would put the "saw it and did not start" bucket back where the
     22% started. */
  var target = frame.querySelector('[data-quiz-target]');

  if (target && embedded && 'IntersectionObserver' in window) {
    var timer = null;
    var reported = false;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (reported) return;

          if (entry.isIntersecting) {
            if (timer) return;
            timer = window.setTimeout(function () {
              reported = true;
              observer.disconnect();
              push('floor_finder_quiz_visible', { quiz_layout: layout });
            }, 1000);
          } else if (timer) {
            window.clearTimeout(timer);
            timer = null;
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(target);
  }

  /* ---- Clicks ------------------------------------------------------------ */

  /* Delegated on the document rather than bound to this section's own button,
     so a jump link anywhere on the page is counted — the closing CTA is a
     bdpet-cta section and is not going to be reshaped to carry a data
     attribute for this. `location` is the enclosing section's key from the JSON
     template, which is how the two are told apart in the report. */
  function locationOf(el) {
    var host = el.closest('.bdpet');
    return (host && host.id) || 'unknown';
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href]') : null;
    if (!link) return;

    var alt = link.getAttribute('data-quiz-alt');
    if (alt) {
      push('floor_finder_alt_path', {
        alt_label: alt,
        alt_href: link.getAttribute('href') || ''
      });
      return;
    }

    if (!anchor) return;

    /* Match the fragment rather than the whole href so a jump link written as
       an absolute URL to the page still counts. */
    var href = link.getAttribute('href') || '';
    var hash = href.indexOf('#') === -1 ? '' : href.slice(href.indexOf('#') + 1);
    if (hash !== anchor) return;

    push('floor_finder_jump_click', {
      quiz_layout: layout,
      cta_location: locationOf(link),
      cta_label: (link.textContent || '').trim().slice(0, 80)
    });
  });
})();
